import Client from "./_client";
import { getDomains } from "./domains";
import { getUsers } from "./users";

export const getTemplates = async (templateFilters = {}) => {
    let url = "/interviewTemplate?";
    Object.keys(templateFilters).forEach((key) => {
        if (templateFilters[key] !== undefined && typeof templateFilters[key] !== "object") url += `${key}=${templateFilters[key]}&`;
        else if (templateFilters[key] !== undefined && typeof templateFilters[key] === "object") {
            templateFilters[key].forEach((el) => url += `${key}[]=${el}&`)
        }
    });
    const result = await new Client({
        path: url,
    }).get();

    if (!(result.ok || result.code === 200))
        throw new Error(result.message || "unable to fetch templates!");

    return result.data || [];
}

export const getTemplateById = async (templateId) => {
    const url = `/template/${templateId}`;

    let result = await new Client({
        path: url,
    }).get();
    if (!(result.ok || result.code === 200)) {
        throw new Error(
            result.message ||
            "Uh Oh! Unable to get template. Please try again."
        );
    }

    return result.data;
}

export const createTemplate = async (template) => {

    let url = `/template`;

    let result = await new Client({
        path: url,
        payload: template,
    }).post();

    if (!(result.ok || result.code === 200)) {
        throw new Error(
            result.message ||
            "Uh Oh! Unable to save template. Please try again."
        );
    }

    return result.data;
}

export const updateTemplateById = async (templateId, template) => {

    let url = `/template/${templateId}`;

    let result = await new Client({
        path: url,
        payload: template,
    }).put();

    if (!(result.ok || result.code === 200)) {
        throw new Error(
            result.message ||
            "Uh Oh! Unable to udpate template. Please try again."
        );
    }

    return result.data;
}

export const deleteTemplateById = async (templateId) => {

    let url = `/interviewTemplate/${templateId}`;

    let result = await new Client({
        path: url
    }).delete();

    if (!(result.ok || result.code === 200))
        throw new Error(
            result.message || "Uh Oh! Unable to delete template. Please try again."
        );

    return result.data;
}

export const getTemplateWithQuestionsById = async (templateId) => {
    let url = `/interviewTemplate/bulk/${templateId}`;
    const result = await new Client({
        path: url,
    }).get();

    if (!(result.ok || result.code === 200)) {
        throw new Error(
            result.message || "Uh Oh! Unable to get template with questions. Please try again."
        );
    }
    if (result.name === "DuplicateSession") {
        return result;
    } else {
        return result.data;
    }
};

export const saveTemplateWithQuestions = async (templateId, interviewTemplate, questions) => {
    let result;
    if (templateId) {
        result = await new Client({
            path: `/interviewTemplate/bulk/${templateId}`,
            payload: {
                interviewTemplate: {
                    ...interviewTemplate,
                },
                questions
            },
        }).patch();
    } else {
        result = await new Client({
            path: `/interviewTemplate/bulk`,
            payload: {
                interviewTemplate,
                questions
            },
        }).post();
    }

    if (!(result.ok || result.code === 200)) {
        throw new Error(
            result.message ||
            "Uh Oh! Unable to save template with questions. Please try again."
        );
    } else {
        return result.data;
    }
};

export const getTemplateFormOptions = async () => {
    const { interviewDomains } = await getDomains();
    const { users } = await getUsers({
        roleNames: ["CLIENT"],
    })

    return {
        domains: interviewDomains,
        clients: users,
    };
};

export const exportTemplates = async (templateIds, clientId, batchId, sep) => {
    let result = await new Client({
        path: `/${sep ? "sepTemplate" : "interviewTemplate"}/bulk/export`,
        payload: {
            templateIds,
            clientId,
            batchId
        },
    }).post();

    if (!(result.ok || result.code === 200)) {
        throw new Error(
            result.message ||
            "Uh Oh! Unable to export template with questions. Please try again."
        );
    } else {
        return result.data;
    }
}

export const exportTemplateWithQuestions = async (
    interviewTemplate, sheetUrl, sheetName
) => {

    let result = await new Client({
        path: '/interviewTemplate/bulk/star',
        payload: {
            interviewTemplate,
            sheetUrl,
            sheetName,
        },
    }).post();

    if (!(result.ok || result.code === 200)) {
        throw new Error(
            result.message ||
            "Uh Oh! Unable to export template with questions. Please try again."
        );
    } else {
        return result.data;
    }
}


